import { RestrictionType } from 'sling-sdk/src/messages/types/RestrictionType';

import { Conversation } from '@web/conversations/types/Conversation';

export const CONVERSATION_PLACEHOLDER: Conversation = {
  creatorId: null,
  firstUnreadMessageId: null,
  id: 0,
  interlocutor: null,
  isArchived: false,
  isDisabled: false,
  isSilenced: false,
  isPinned: false,
  isPrivate: false,
  memberIds: [],
  restricted: RestrictionType.NONE,
  restrictedToPersonas: [],
  name: '',
  newestMessageId: 0,
  newestMessagePostedAt: new Date(),
  newestUnsilencedMessagePostedAt: new Date(),
  slug: '',
  unreadMessagesCount: 0,
};
